// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import { Action } from "redux"
import { RootState } from "../../../app/store"
import { storagePrefix } from "../../../app/config"
import searchRecentManualTimeComments from "./searchRecentManualTimeComments"
import addManualTime from "./addManualTime"
import loadActivity from "./loadActivity"
import persistActivity from "./persistActivity"

export const MANUAL_TIME_ACTIVITY = storagePrefix + "manual_time_activity"

export default combineEpics<Action, Action, RootState, unknown>(
  searchRecentManualTimeComments,
  addManualTime,
  
  loadActivity,
  persistActivity,
)
